import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { headers } from "./jsonHeader";
export default function refreshToken(_x) {
  return _refreshToken.apply(this, arguments);
}

function _refreshToken() {
  _refreshToken = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(url) {
    var promise;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!url) {
              _context.next = 8;
              break;
            }

            _context.next = 3;
            return fetch(url, {
              headers: headers,
              method: "GET",
              credentials: "same-origin"
            });

          case 3:
            promise = _context.sent;

            if (!promise.ok) {
              _context.next = 8;
              break;
            }

            _context.next = 7;
            return promise.json();

          case 7:
            return _context.abrupt("return", _context.sent);

          case 8:
            throw new Error("No url.");

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _refreshToken.apply(this, arguments);
}